import axios from "axios";

const uploadMixin = {
  // data(){
  //   return {
  //     fileList: [],
  //     fileList1: [],
  //   }
  // },
  methods: {
    onOversize(file) {
      // console.log(file);
      const fileSize = Math.floor(parseInt(file.size) / 1024)
      this.$toast(`文件大小(${fileSize}) 不能超过 5000kb`);
    },
    _afterRead(file, type, fileList, fileList1, fileNameMap){
      // 同时上传多张图片时file是array
      if (Array.isArray(file)) {
        file.forEach(item => {
          this.__afterRead(item, type, fileList, fileList1, fileNameMap)
        })
        return
      }
      this.__afterRead(file, type, fileList, fileList1, fileNameMap)
    },
    async __afterRead(file, type, fileList, fileList1, fileNameMap) {
      try {
        const token = await this.$api.post("contract/member/file/update/token", { type: type })
        const fileNames = /.+\.([^.]*$)/.exec(file.file.name)
        let ext = ''
        if (fileNames && fileNames.length >= 2) {
          ext = fileNames[1]
        }
        let formData = new FormData()
        formData.append('token', token.token)
        formData.append('file', file.file)
        formData.append('key', `${token.file_path}.${ext}`)

        const res = await axios.post("https://up-z0.qiniup.com", formData)
        fileList1.push(res.key)
        // 记录file name 对应关系，用于删除时同步删除fileList1里的内容
        fileNameMap[file.file.name] = `${token.file_path}.${ext}`
      } catch (error) {
        console.log(error);
        // 清除预览
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].file.name === file.file.name) {
            fileList.splice(i,1)
            break
          }
        }
        this.$toast('图片上传失败，请重新上传')
      }
    },
    // fix: 修复部分机型取消上传还是会暂时空白图片
    beforeRead(file){
      if (! file.size) {
        return false
      }
      return true
    },
    deleteFile(file, fileList1, fileNameMap){
      console.log('delete--file')
      console.log(file)
      console.log(fileList1)
      console.log(fileNameMap)
      for (let i = 0; i < fileList1.length; i++) {
        if (fileList1[i] === fileNameMap[file.file.name]) {
          fileList1.splice(i,1)
          fileNameMap[file.file.name] = undefined
          break
        }
      }
    },
  }
}

export {uploadMixin}
